/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SyncCompaniesToKlaviyoRequest
 */
export interface SyncCompaniesToKlaviyoRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof SyncCompaniesToKlaviyoRequest
   */
  companyIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SyncCompaniesToKlaviyoRequest
   */
  listId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncCompaniesToKlaviyoRequest
   */
  newListName?: string | null;
}

/**
 * Check if a given object implements the SyncCompaniesToKlaviyoRequest interface.
 */
export function instanceOfSyncCompaniesToKlaviyoRequest(
  value: object,
): value is SyncCompaniesToKlaviyoRequest {
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  return true;
}

export function SyncCompaniesToKlaviyoRequestFromJSON(
  json: any,
): SyncCompaniesToKlaviyoRequest {
  return SyncCompaniesToKlaviyoRequestFromJSONTyped(json, false);
}

export function SyncCompaniesToKlaviyoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SyncCompaniesToKlaviyoRequest {
  if (json == null) {
    return json;
  }
  return {
    companyIds: json["companyIds"],
    listId: json["listId"] == null ? undefined : json["listId"],
    newListName: json["newListName"] == null ? undefined : json["newListName"],
  };
}

export function SyncCompaniesToKlaviyoRequestToJSON(
  json: any,
): SyncCompaniesToKlaviyoRequest {
  return SyncCompaniesToKlaviyoRequestToJSONTyped(json, false);
}

export function SyncCompaniesToKlaviyoRequestToJSONTyped(
  value?: SyncCompaniesToKlaviyoRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyIds: value["companyIds"],
    listId: value["listId"],
    newListName: value["newListName"],
  };
}
